module.exports = __webpack_public_path__ + "img/ic_24_social_email.7f7a4fd5.svg";